'use strict';

var Core     = require('./core.js');
var $         = require('jquery');
// var interact = require('interact.js');

/**
 * InspectorCore
 * inherits from Core, extends jQuery to allow getting cursor position and selecting cursor placement
 */

class InspectorCore extends Core  {
	constructor(options) {
        super(options);

    }

    selectRange(start, end) {
    	if (typeof end === 'undefined') {
			end = start;
		}
		var el = this.$el.find(":input");
		return el.each(function () {
			if ('selectionStart' in this) {
				this.selectionStart = start;
				this.selectionEnd = end;
			} else if (this.setSelectionRange) {
				this.setSelectionRange(start, end);
			} else if (this.createTextRange) {
				var range = this.createTextRange();
				range.collapse(true);
				range.moveEnd('character', end);
				range.moveStart('character', start);
				range.select();
			}
		});
    }

    getCursorPosition() {
    	var el = this.$el.find(":input").get(0);
		var pos = 0;
		if('selectionStart' in el) {
			pos = el.selectionStart;
		} else if('selection' in document) {
			el.focus();
			var Sel = document.selection.createRange();
			var SelLength = document.selection.createRange().text.length;
			Sel.moveStart('character', -el.value.length);
			pos = Sel.text.length - SelLength;
		}
		return pos;
    }
}

module.exports = InspectorCore;